module.exports = __webpack_public_path__ + "static/media/SWSCRC6-18.e5281b88.mp3";